import { render, staticRenderFns } from "./NewAyudaRepRetenciones.vue?vue&type=template&id=407fb6d2&scoped=true"
import script from "./NewAyudaRepRetenciones.vue?vue&type=script&lang=js"
export * from "./NewAyudaRepRetenciones.vue?vue&type=script&lang=js"
import style0 from "./NewAyudaRepRetenciones.vue?vue&type=style&index=0&id=407fb6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407fb6d2",
  null
  
)

export default component.exports